<template>
    <div>
        <CHeading>Pravidlá používania cookies</CHeading>

        <CCardBox> Koláčiky na GROWNi.sk </CCardBox>
    </div>
</template>

<script setup lang="ts">
definePageMeta({
    layout: 'default'
})

const { t: $t } = useI18n()
useHead({
    title: $t('cookies.title'),
    meta: [{ name: 'description', content: $t('cookies.description') }]
})
</script>
